


export default function financeCalculator() {

    function o() {
        let c = $("#finance-calculator-paymentfrequency").val(),
            financeamount = $("#amount_hidden").val(),
            h = parseInt(e),
            u = $("#term_hidden").val(),
            totalcost,
            interestcost,
            f,
            t;
        let Rate = r / 1200;
        let payment = h * Rate / (1 - Math.pow(1 / (1 + Rate), u));
        totalcost = payment * u + i * u;
        interestcost = payment * u - financeamount;
        switch (c) {
            case "fortnightly":
                f = r / 26 * .01;
                t = u / 12 * 26;
                payment = h * f / (1 - Math.pow(1 / (1 + f), t));
                totalcost = payment * t + i * u;
                interestcost = payment * t - financeamount;
                break;
            case "weekly":
                f = r / 52 * .01;
                t = u / 12 * 52;
                payment = h * f / (1 - Math.pow(1 / (1 + f), t));
                totalcost = payment * t + i * u;
                interestcost = payment * t - financeamount
        }
        payment = n(payment + i);
        $("#finance-calculator-financeamount").html(n(financeamount));
        $("#finance-calculator-payment").html(payment);
        $("#finance-calculator-totalcost").html(n(totalcost));
        $("#finance-calculator-interestcost").html(n(interestcost))
    }

    function n(n) {
        return n = isNaN(n) || n === "" || n === null ? 0 : n,
        "$" + parseFloat(n).format(2, 3)
    }

    function a(n) {
        var i = 20
            , t = n;
        return t > 0 && t <= 12 ? i = 50 : t > 12 && t <= 24 ? i = 40 : t > 24 && t <= 36 ? i = 30 : t > 36 && t <= 48 ? i = 20 : t > 48 && (i = 0),
            i
    }

    var t = Number($("#finance_car_price").val())
        , s = 300
        , c = 0
        , h = 11
        , u = 48
        , f = Math.round(t / 5)
        , r = 7.5
        , i = 4
        , l = u * i
        , e = t - f + s + h + c;
    $("#finance-calculator-retailprice").html(n(t));
    $("#finance-deposit-display").html(n(f));
    $("#desposit_hidden").val(f);
    $("#finance-deposit-range").val(u);
    $("#term_hidden").val(u);
    $("#finance-calculator-originationfee").html(n(s));
    $("#finance-calculator-maintenancefee").html(n(l));
    $("#finance-calculator-maintenancefeepermonth").html("($" + i + "/month)");
    $("#finance-calculator-ppsr").html(n(h));
    $("#finance-calculator-interestrate").html(r + "%");
    $("#amount_hidden").val(e);
    o();
    $("#finance-calculator-paymentfrequency").change(function () {
        o();
    });

    $('#finance-deposit-range').on('input', function () {
        var u = $(this).val(), f, l;
        u > t && (u = t);
        $("#finance-deposit-display").html(n(u));
        $("#deposit_hidden").val(u);
        f = $("#term_hidden").val();
        l = a(f);
        e = t - $(this).val() + s + h + c;
        $("#amount_hidden").val(e);
        // $("#amountSpn").html(n(e));
        o();
    }).trigger('input');

    $('#finance-term-range').on('input', function () {
        let u = $(this).val();
        $("#finance-term-display").html(u);
        $("#term_hidden").val(u);
        $("#finance-calculator-maintenancefee").html(n(u * i));
        o();
    }).trigger('input');

};